module.exports = __webpack_public_path__ + "media/images/barnardos-stat-c3bbda2bf582b6933718b993959b199f.jpg";